// extracted by mini-css-extract-plugin
module.exports = {"container":"Comments_container__1dD-m","comment":"Comments_comment__3hpyx","header":"Comments_header__A98fU","textarea":"Comments_textarea__1bXdO"};